import { API_SERVER_URL } from 'config';
import {
  createRequestUrl,
  defaultOptions,
  isPayloadEmpty,
  sendRequest,
  transformPayload,
} from 'services/utils';

const getData = async (endpoint, token = null) => {
  const options = defaultOptions('GET');
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: token,
    };
  }
  const request = new Request(
    createRequestUrl(API_SERVER_URL, endpoint),
    options,
  );

  return await sendRequest(request);
};

const createData = async (
  endpoint,
  payload = {},
  token = null,
  files = false,
  params = {},
) => {
  const options = defaultOptions('POST');
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: token,
    };
  }
  options.body = files ? payload : transformPayload(payload);
  const request = new Request(
    createRequestUrl(API_SERVER_URL, endpoint, params),
    options,
  );

  return await sendRequest(request);
};

const deleteData = async (endpoint, payload = {}, token = null) => {
  const options = defaultOptions('DELETE');
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: token,
    };
  }
  if (!isPayloadEmpty(payload)) {
    options.body = transformPayload(payload);
  }
  const request = new Request(
    createRequestUrl(API_SERVER_URL, endpoint),
    options,
  );

  return await sendRequest(request);
};

const modifyData = async (endpoint, payload = {}, token = null) => {
  const options = defaultOptions('PUT');
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: token,
    };
  }
  options.body = transformPayload(payload);
  const request = new Request(
    createRequestUrl(API_SERVER_URL, endpoint),
    options,
  );

  return await sendRequest(request);
};

export { createData, deleteData, getData, modifyData };
